module.exports = __webpack_public_path__ + "img/toilet-paper-blank-under.08dd33be.svg";